<!--列表查看视图-->
<template>
  <el-dialog
    v-el-drag-dialog
    custom-class="related-ai-from-window"
    :visible.sync="innerVisible"
    :title="$t('SeaExport.AssociationBusinessInformationSI')"
    :close-on-click-modal="true"
    @close="innerVisible=false"
  >
    <div class="main-content">
      <div :class="'tabs-container' + (canOperateJob ? '' : ' cannot-operate-job')">
        <span class="lab-state">{{ labState }}</span>
        <el-tabs ref="tabs" v-model="activeTabName" type="card" @tab-click="handleTabClick">
          <el-tab-pane v-if="currentRow && !currentRow.masterFlag" name="tabBookingFCL" :label="$t('SeaExport.ImportOperation')">
            <tab-booking-fcl ref="tabBookingFCL" :context="context" :action="action" />
          </el-tab-pane>
          <el-tab-pane v-if="currentRow && currentRow.masterFlag" name="tabBookingMaster" :label="$t('SeaExport.ImportOperation')">
            <tab-booking-master ref="tabBookingMaster" :context="context" :action="action" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { BookingWorkspaceContext } from '@/views/cargo/v0/AirImport/components/booking/bookingWorkspaceContext'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import tabBookingFcl from '@/views/cargo/v0/AirImport/components/booking/tabs/tabBookingFCL.vue'
import tabBookingMaster from '@/views/cargo/v0/AirImport/components/booking/tabs/tabBookingMaster.vue'
export default {
  name: 'RelatedAiFromWindow',
  components: {
    tabBookingFcl,
    tabBookingMaster
  },
  props: {
    visible: { type: Boolean, required: true },
    relatedJob: { type: Object, required: false, default: null },
    canOperateJob: { type: Boolean, default: true }
  },
  data() {
    return {
      context: new BookingWorkspaceContext(),
      loading: false,
      showButton: false,
      innerVisible: false,
      action: 'look',
      currentRow: {},
      activeTabName: 'tabBookingFCL',
      labState: ''
    }
  },
  watch: {
    async visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    if (this.visible) {
      const loading = getLoading4Cxt()
      try {
        this.innerVisible = true
        await this.context.prepareData()
        console.log('context', this.context)
        await this.showDetail(this.relatedJob)
      } finally {
        loading.close()
      }
    }
  },
  methods: {
    async showDetail(relatedJob) {
      this.currentRow = relatedJob
      this.currentRow.path = ''
      this.labState = this.$t('SeaExport.BusinessStatus') + '：' + ColumnUtils.getJobStateCN(this.currentRow.jobState)
      this.activeTabName = this.currentRow.masterFlag ? 'tabBookingMaster' : 'tabBookingFCL'
      this.handleTabClick()
    },
    handleTabClick() {
      this.$nextTick(() => {
        this.$refs[this.activeTabName].onShow(this.currentRow, true)
      })
    }
  }
}
</script>

<style lang="scss">
.el-dialog.related-ai-from-window {
  display: flex;
  height: 600px;
  width: 1415px;
  flex-direction: column;
  .el-dialog {
    &__body {
      position: relative;
      display: flex;
      overflow: hidden;
    }
  }
  &.isfullScreen {
    overflow: hidden;
  }
  .el-tabs {
    display: flex;
    flex-direction: column;
    width: 100%;
    &__content {
      overflow: scroll;
    }
  }
  .lab-state {
    position: absolute;
    z-index: 999;
    right: 30%;
  }
  .tabs-container.cannot-operate-job {
    .el-button {
      &.el-button--primary:not(.can-operate) {
        pointer-events: none;
        color: #FFFFFF;
        background-color: #8fbaea;
        border-color: #8fbaea;
      }
      &.el-button--success:not(.can-operate) {
        pointer-events: none;
        color: #FFFFFF;
        background-color: #a1dcc1;
        border-color: #a1dcc1;
      }
      &.el-button--danger:not(.can-operate) {
        pointer-events: none;
        color: #FFFFFF;
        background-color: #fab6b6;
        border-color: #fab6b6;
      }
    }
    .sop-img {
      pointer-events: none;
    }
  }
}
</style>
